module.exports = __webpack_public_path__ + "img/af0c72b.jpg";